module.exports = __webpack_public_path__ + "static/media/image6.659313ad.jpg";